import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import { from } from 'rxjs';
import { TopicsTree } from './model';
import { SyllabusAndCourseLevel } from './syllabus';

@Injectable({
  providedIn: 'root',
})
export class CategoryHttpService {
  constructor(private readonly supabase: ExamdojoSupabaseService) {}

  fetchTopicsTree() {
    return from(
      this.supabase.client
        .schema('categories')
        .from('topics_tree')
        .select()
        .throwOnError()
        .then((response) => response.data![0].jsonb_agg as TopicsTree),
    );
  }

  fetchGradeBoundaries({ syllabusId, courseLevel }: SyllabusAndCourseLevel) {
    let query = this.supabase.client
      .schema('categories')
      .from('grade_boundaries')
      .select()
      .eq('syllabus_id', syllabusId);

    if (courseLevel) {
      query = query.eq('course_level', courseLevel);
    }

    return from(query.throwOnError().then((response) => response.data));
  }
}
